import { createFileRoute } from '@tanstack/react-router'
import { PartnerDashboard } from '../../../components/PartnerDashboard'

export const Route = createFileRoute('/admin/organizations/assignments/$organizationId')({
  component: AdminOrganizationAssignmentsPage,
})

function AdminOrganizationAssignmentsPage() {
  const { organizationId } = Route.useParams()
  return <PartnerDashboard organizationId={organizationId} />
}
